import React from "react";
import { UserListComponent } from "lib/components/common/user-list";
import { ROUTE_PATH } from "router/router-constant/router.constant";

export const UserListPage = () => {
  return (
    <UserListComponent
      pageTitle="لیست کاربران"
      showActions
      backUrl={ROUTE_PATH.users.list.path}
    />
  );
};
